module.exports = __webpack_public_path__ + "static/tomasz-default-23b5e07ec69cb3a31615a32937183a77.png";